/* eslint-disable react/jsx-filename-extension */
import React from 'react'
import PropTypes from 'prop-types'
import { IonIcon } from 'controls'
import { iadProvitionalColors } from 'theme/colors'

import ModalConfirm from '../ModalConfirm'

import styles from './styles'

const ParentConfirmModal = ({
  isOpen,
  onConfirm,
  onCancel,
  parentName,
  loading
}) => (
  <ModalConfirm
    // eslint-disable-next-line react/jsx-boolean-value
    showRejectButton={true}
    isOpen={isOpen}
    onConfirm={onConfirm}
    onCancel={onCancel}
    buttonConfirmLabel="Sí, elegir padrino"
    buttonRejectLabel="Cancelar"
    loading={loading}
    message=""
  >
    <IonIcon
      size="large"
      style={{ color: iadProvitionalColors.primary }}
      icon="md-person-circle-outline"
    />
    <h3 className="title">Confirmar selección de padrino</h3>
    <p className="message">
      Vas a elegir a
      {' '}
      <strong>{parentName}</strong>
      {' '}
      como tu padrino dentro de la red. ¿Quieres continuar con esta opción?
    </p>
    <p className="submessage">
      Esta decisión es muy importante.
      La selección de padrino solo puede hacerse una vez, posteriormente si se quiere hacer un cambio, es necesaria la autorización de la red.
    </p>
    <style jsx>{styles}</style>
  </ModalConfirm>
)

ParentConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  parentName: PropTypes.string,
  loading: PropTypes.bool,
}

ParentConfirmModal.defaultProps = {
  parentName: 'este asesor',
  loading: false,
}

export default ParentConfirmModal
